import React, { useReducer, useState } from "react";
import { useTranslation } from "react-i18next";
import ApprovedIcon from "../../../../assets/icons/stepsIcons/ApprovedIcon";
import { SearchModal } from "./modal/searchModal";
import { CountryLink } from "./style";

export default function Conditions() {
  function openModal() {
    setModalIsOpen(true);
  }
  function toggleModal() {
    setModalIsOpen(false);
  }
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [searchModal, setSearchModal] = useReducer(
    (info, newInfo) => ({ ...info, ...newInfo }),
    {
      heading: "",
      body: "",
    }
  );
  const { t } = useTranslation();
  return (
    <>
      <div className={"agreementTextWrapper"}>
        <div className="mr-4">
          <ApprovedIcon />
        </div>
        <p>
          <span>{t("condition1")}</span>
        </p>
      </div>
      <div className={"agreementTextWrapper"}>
        <div className="mr-4">
          <ApprovedIcon />
        </div>
        <span>{t("condition2")}</span>
      </div>
      <div className={"agreementTextWrapper"}>
        <div className="mr-4">
          <ApprovedIcon />
        </div>
        <p>
          <span>{t("condition4")}</span>
          <CountryLink
            onClick={() => {
              openModal();
            }}
          >
            {t("listedCountries")}
          </CountryLink>
        </p>
      </div>
      <div className={"agreementTextWrapper"}>
        <div className="mr-4">
          <ApprovedIcon />
        </div>
        <p>
          <span>{t("condition5")}</span>
          <CountryLink
            onClick={() => {
              openModal();
            }}
          >
            {t("listedCountry")}
          </CountryLink>
          <span>{t("citizens")}</span>
        </p>
      </div>
      <div className={"agreementTextWrapper"}>
        <div className="mr-4">
          <ApprovedIcon />
        </div>
        <p>
          <span>{t("condition6")}</span>
          <CountryLink
            onClick={() => {
              openModal();
            }}
          >
            {t("listedCountry")}
          </CountryLink>
          <span>{t("citizens")}</span>
        </p>
      </div>
      <div className={"agreementTextWrapper"}>
        <div className="mr-4">
          <ApprovedIcon />
        </div>
        <span>{t("condition7")}</span>
      </div>
      <SearchModal isOpen={modalIsOpen} onToggle={toggleModal} />
    </>
  );
}
